<div class="step-card">
  <div class="step-card-header">
    <div class="step-card-title" style="font-weight:700;font-family:'Poppins',sans-serif;">
      {{ meetingBooked ? 'Meeting Booked' : 'Book your Meeting' }}
    </div>
    <div class="step-card-subtitle" *ngIf="!meetingBooked">
      Schedule your onboarding session now to unlock personalized guidance and start making the most of your new tools right away.
    </div>
  </div>
  <!-- ── API-based scheduler (default) ── -->
  <div *ngIf="useApiScheduler" class="step-card-body meeting-card-body">
    <app-meeting-scheduler (booked)="onSchedulerBooked()"></app-meeting-scheduler>
  </div>

  <!-- ── HubSpot JS embed (fallback) ── -->
  <div *ngIf="!useApiScheduler" class="step-card-body meeting-card-body" style="position:relative;">
    <div *ngIf="showCalendar"
         class="meetings-iframe-container w-100"
         [attr.data-src]="hubspotEmbedUrl"></div>

    <!-- White overlay covers the "Create your own meeting booking page" promo link
         at the bottom of HubSpot's cross-origin iframe (cannot remove via CSS) -->
    <div *ngIf="meetingBooked"
         style="position:absolute;bottom:0;left:0;right:0;height:48px;background:#fff;"></div>

    <div *ngIf="!showCalendar"
         class="d-flex justify-content-center align-items-center"
         style="height:300px;background:#f5f5f5;border-radius:8px;color:#667085">
      <div class="text-center">
        <i class="material-icons" style="font-size:48px;color:#c0c0c0">calendar_month</i>
        <div class="mt-2">Calendar coming soon</div>
      </div>
    </div>
  </div>
</div>

<div class="step-footer">
  <div class="d-flex justify-content-end" style="gap:8px">
    <button class="button small cancel-button" (click)="skip()" *ngIf="!meetingBooked">Skip for now</button>
    <button class="button small" (click)="next()" [disabled]="checkingMeeting">
      {{ checkingMeeting ? 'Checking...' : 'Next' }}
    </button>
  </div>
</div>
